import { createDeleteEndpoint } from '@sonar-software/sonar-http';

export type DeleteInitiativeLinkRequest = {
	id: number;
	initiativeId: number;
};

export const deleteInitiativeLink = createDeleteEndpoint<DeleteInitiativeLinkRequest>(
	({ id, initiativeId }) => `/api/v3/initiatives/${initiativeId}/links/${id}`
);
